<template>
<div>
	<div class="title">发票信息
		<RadioGroup v-model="form.invoiceType" @on-change="typeChange" class="ml15" :disabled="disabled">
	        <Radio label="PLAIN">普票</Radio>
	        <Radio label="VAT" v-if="type=='COMPANY'">专票</Radio>
	        <Radio label="NOT">不开发票</Radio>
	    </RadioGroup>
	</div>
	<Form :model="form" :label-width="150" class="mt15" ref="form" :rules="invoiceValidate" v-if="form.invoiceType!='NOT'">
	    <FormItem :label="type=='COMPANY'?'公司名称':'开票人姓名'" class="w600" prop="invoiceName">
	        <!-- {{form.invoiceName}} -->
			<Input v-model="form.invoiceName" :placeholder="type=='COMPANY'?'请输入公司名称':'请输入开票人姓名'" :maxlength="50"></Input>
	    </FormItem>
		<div v-if="type=='COMPANY'">
			<FormItem label="统一社会信用代码" class="w600" prop="invoiceUniqueCode" v-if="type=='COMPANY'">
				<!-- {{form.invoiceUniqueCode}} -->
				<Input v-model="form.invoiceUniqueCode" placeholder="请输入统一社会信用代码" :maxlength="50"></Input>
			</FormItem>
			<FormItem label="地址" class="w600" prop="invoiceAddress">
				<Input v-model="form.invoiceAddress" placeholder="请输入开票地址" :maxlength="50"></Input>
			</FormItem>
			<FormItem label="电话" class="w600" prop="invoicePhone">
				<Input v-model="form.invoicePhone" placeholder="请输入开票电话" :maxlength="20"></Input>
			</FormItem>
			<FormItem label="开户行" class="w600" prop="openingBankName">
				<Input v-model="form.openingBankName" placeholder="请输入开户行" :maxlength="30"></Input>
			</FormItem>
			<FormItem label="银行账号" class="w600" prop="openingBankAccount">
				<Input v-model="form.openingBankAccount" placeholder="请输入对公账号" :maxlength="30"></Input>
			</FormItem>
		</div>
		<!-- <FormItem label="电子邮箱" class="w600" prop="invoiceDeliverEmail" v-if="form.invoiceType=='VAT'" key="invoiceDeliverEmail">
			<Input v-model="form.invoiceDeliverEmail" placeholder="请输入电子邮箱" :maxlength="100"></Input>
		</FormItem> -->
		<FormItem label="邮寄地址" class="w600" prop="invoiceDeliverAddress" key="invoiceDeliverAddress">
			<Input v-model="form.invoiceDeliverAddress" placeholder="请输入邮寄地址" :maxlength="100"></Input>
		</FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		type:{
			type:String,
			default:'COMPANY' // 企业COMPANY，个人PERSON
		},
	},
	watch:{
		info (data) {
			console.log(data)
		}
	},
	data () {
		return {
			form:{},
			invoiceValidate:{
				invoiceName:{required:true,message:'请输入开票名称',trigger:'blur'},
				invoiceUniqueCode:{required:true,message:'请输入统一社会信用代码',trigger:'blur'},
				invoiceAddress:{required:true,message:'请输入开票地址',trigger:'blur'},
				invoicePhone:{required:true,message:'请输入开票电话',trigger:'blur'},
				openingBankName:{required:true,message:'请输入开户行',trigger:'blur'},
				openingBankAccount:{required:true,message:'请输入对公账号',trigger:'blur'},
				// invoiceDeliverEmail:[{required:true,message:'请输入电子邮箱',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.email}],
				invoiceDeliverAddress:{required:true,message:'请输入邮寄地址',trigger:'blur'}
			}
		}
	},
	computed:{
		disabled(){
			if(this.type=='COMPANY'){
				return Boolean(!this.form.invoiceName||!this.form.invoiceUniqueCode)
			}else{
				return Boolean(!this.form.invoiceName)
			}
		}
	},
	watch:{
		info (val) {
			this.initData()
		},
	},
	created(){
		this.initData()
	},
	methods:{
		initData(){
			let info=this.jsonCopy(this.info)
			this.form={
				...this.form,
				...info,
				invoicePhone:this.form.invoicePhone||info.invoicePhone||'',
				invoiceAddress:this.form.invoiceAddress||info.invoiceAddress||'',
				// invoiceDeliverEmail:this.form.invoiceDeliverEmail||info.invoiceDeliverEmail||'',
			}
		},
		typeChange(val){
			// this.$nextTick(()=>{
			// 	if(val=='VAT'&&this.form.invoiceDeliverEmail){
			// 		this.$refs.form.validateField('invoiceDeliverEmail')
			// 	}
			// })
		},
		async sub () {
			if(this.form.invoiceType=='NOT'){
				return {
					invoiceType:'NOT'
				}
			}else if(await this.$refs.form.validate()){
				if(this.type=='PERSON'){
					return {
						invoiceType:this.form.invoiceType,
						invoiceName:this.form.invoiceName,
						// invoiceDeliverEmail:this.form.invoiceType=='VAT'?this.form.invoiceDeliverEmail:'',
						invoiceDeliverAddress:this.form.invoiceDeliverAddress,
					}
				}
				return this.form
			}else{
				this.toast('发票信息校验失败','error');
				return false
			}
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/Invoice.vue